// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"12cbcf5a59ac1176680e","655":"a0e667b427c748de3f8b"}[chunkId] + ".js";
};